import React from "react";
// Styles
import styles from "./polaroid-image.module.css";

function VerticalPolaroidImage(props) {
  const { image, caption, className = "", aspectRatio, onClick } = props;

  const handleOverlayContextMenu = (event) => {
    event.preventDefault();
  };

  return (
    <div
      className={`polaroid-image ${styles.polaroidFrame} ${styles.polaroidFrameVertical} boxShadow ${className}`}
      onClick={onClick}
    >
      <img
        src={image}
        className={`${styles.polaroidImageVertical} ${aspectRatio}`}
      />
      <p className={styles.polaroidCaption}>{caption}</p>
      <div
        className={styles.transparentOverlay}
        onContextMenu={handleOverlayContextMenu}
      />
    </div>
  );
}

export default VerticalPolaroidImage;
